// Maybe use it the right way ?
// https://tailwindcss.nuxtjs.org/tailwind/config#referencing-in-the-application
// import colors from '#tailwind-config/theme/colors'  // named (with _ prefix)

export const colors = {
  inherit: "inherit",
  current: "currentColor",
  transparent: "transparent",
  black: "#000",
  white: "#fff",
  slate: {
    50: "#f8fafc",
    100: "#f1f5f9",
    200: "#e2e8f0",
    300: "#cbd5e1",
    400: "#94a3b8",
    500: "#64748b",
    600: "#475569",
    700: "#334155",
    800: "#1e293b",
    900: "#0f172a",
    950: "#020617",
  },
  gray: {
    50: "#f9fafb",
    100: "#f3f4f6",
    200: "#e5e7eb",
    300: "#d1d5db",
    400: "#9ca3af",
    500: "#6b7280",
    600: "#4b5563",
    700: "#374151",
    800: "#1f2937",
    900: "#111827",
    950: "#030712",
  },
  zinc: {
    50: "#fafafa",
    100: "#f4f4f5",
    200: "#e4e4e7",
    300: "#d4d4d8",
    400: "#a1a1aa",
    500: "#71717a",
    600: "#52525b",
    700: "#3f3f46",
    800: "#27272a",
    900: "#18181b",
    950: "#09090b",
  },
  neutral: {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#e5e5e5",
    300: "#d4d4d4",
    400: "#a3a3a3",
    500: "#737373",
    600: "#525252",
    700: "#404040",
    800: "#262626",
    900: "#171717",
    950: "#0a0a0a",
  },
  stone: {
    50: "#fafaf9",
    100: "#f5f5f4",
    200: "#e7e5e4",
    300: "#d6d3d1",
    400: "#a8a29e",
    500: "#78716c",
    600: "#57534e",
    700: "#44403c",
    800: "#292524",
    900: "#1c1917",
    950: "#0c0a09",
  },
  red: {
    50: "#fef2f2",
    100: "#fee2e2",
    200: "#fecaca",
    300: "#fca5a5",
    400: "#f87171",
    500: "#ef4444",
    600: "#dc2626",
    700: "#b91c1c",
    800: "#991b1b",
    900: "#7f1d1d",
    950: "#450a0a",
  },
  orange: {
    50: "#fff7ed",
    100: "#ffedd5",
    200: "#fed7aa",
    300: "#fdba74",
    400: "#fb923c",
    500: "#f97316",
    600: "#ea580c",
    700: "#c2410c",
    800: "#9a3412",
    900: "#7c2d12",
    950: "#431407",
  },
  amber: {
    50: "#fffbeb",
    100: "#fef3c7",
    200: "#fde68a",
    300: "#fcd34d",
    400: "#fbbf24",
    500: "#f59e0b",
    600: "#d97706",
    700: "#b45309",
    800: "#92400e",
    900: "#78350f",
    950: "#451a03",
  },
  yellow: {
    50: "#fefce8",
    100: "#fef9c3",
    200: "#fef08a",
    300: "#fde047",
    400: "#facc15",
    500: "#eab308",
    600: "#ca8a04",
    700: "#a16207",
    800: "#854d0e",
    900: "#713f12",
    950: "#422006",
  },
  lime: {
    50: "#f7fee7",
    100: "#ecfccb",
    200: "#d9f99d",
    300: "#bef264",
    400: "#a3e635",
    500: "#84cc16",
    600: "#65a30d",
    700: "#4d7c0f",
    800: "#3f6212",
    900: "#365314",
    950: "#1a2e05",
  },
  green: {
    50: "#f0fdf4",
    100: "#dcfce7",
    200: "#bbf7d0",
    300: "#86efac",
    400: "#4ade80",
    500: "#22c55e",
    600: "#16a34a",
    700: "#15803d",
    800: "#166534",
    900: "#14532d",
    950: "#052e16",
  },
  emerald: {
    50: "#ecfdf5",
    100: "#d1fae5",
    200: "#a7f3d0",
    300: "#6ee7b7",
    400: "#34d399",
    500: "#10b981",
    600: "#059669",
    700: "#047857",
    800: "#065f46",
    900: "#064e3b",
    950: "#022c22",
  },
  teal: {
    50: "#f0fdfa",
    100: "#ccfbf1",
    200: "#99f6e4",
    300: "#5eead4",
    400: "#2dd4bf",
    500: "#14b8a6",
    600: "#0d9488",
    700: "#0f766e",
    800: "#115e59",
    900: "#134e4a",
    950: "#042f2e",
  },
  cyan: {
    50: "#ecfeff",
    100: "#cffafe",
    200: "#a5f3fc",
    300: "#67e8f9",
    400: "#22d3ee",
    500: "#06b6d4",
    600: "#0891b2",
    700: "#0e7490",
    800: "#155e75",
    900: "#164e63",
    950: "#083344",
  },
  sky: {
    50: "#f0f9ff",
    100: "#e0f2fe",
    200: "#bae6fd",
    300: "#7dd3fc",
    400: "#38bdf8",
    500: "#0ea5e9",
    600: "#0284c7",
    700: "#0369a1",
    800: "#075985",
    900: "#0c4a6e",
    950: "#082f49",
  },
  blue: {
    50: "#eff6ff",
    100: "#dbeafe",
    200: "#bfdbfe",
    300: "#93c5fd",
    400: "#60a5fa",
    500: "#3b82f6",
    600: "#2563eb",
    700: "#1d4ed8",
    800: "#1e40af",
    900: "#1e3a8a",
    950: "#172554",
  },
  indigo: {
    50: "#eef2ff",
    100: "#e0e7ff",
    200: "#c7d2fe",
    300: "#a5b4fc",
    400: "#818cf8",
    500: "#6366f1",
    600: "#4f46e5",
    700: "#4338ca",
    800: "#3730a3",
    900: "#312e81",
    950: "#1e1b4b",
  },
  violet: {
    50: "#f5f3ff",
    100: "#ede9fe",
    200: "#ddd6fe",
    300: "#c4b5fd",
    400: "#a78bfa",
    500: "#8b5cf6",
    600: "#7c3aed",
    700: "#6d28d9",
    800: "#5b21b6",
    900: "#4c1d95",
    950: "#2e1065",
  },
  purple: {
    50: "#faf5ff",
    100: "#f3e8ff",
    200: "#e9d5ff",
    300: "#d8b4fe",
    400: "#c084fc",
    500: "#a855f7",
    600: "#9333ea",
    700: "#7e22ce",
    800: "#6b21a8",
    900: "#581c87",
    950: "#3b0764",
  },
  fuchsia: {
    50: "#fdf4ff",
    100: "#fae8ff",
    200: "#f5d0fe",
    300: "#f0abfc",
    400: "#e879f9",
    500: "#d946ef",
    600: "#c026d3",
    700: "#a21caf",
    800: "#86198f",
    900: "#701a75",
    950: "#4a044e",
  },
  pink: {
    50: "#fdf2f8",
    100: "#fce7f3",
    200: "#fbcfe8",
    300: "#f9a8d4",
    400: "#f472b6",
    500: "#ec4899",
    600: "#db2777",
    700: "#be185d",
    800: "#9d174d",
    900: "#831843",
    950: "#500724",
  },
  rose: {
    50: "#fff1f2",
    100: "#ffe4e6",
    200: "#fecdd3",
    300: "#fda4af",
    400: "#fb7185",
    500: "#f43f5e",
    600: "#e11d48",
    700: "#be123c",
    800: "#9f1239",
    900: "#881337",
    950: "#4c0519",
  },
  rnxblue: {
    // https://www.tailwindshades.com/#color=222.46753246753246%2C63.63636363636365%2C47.45098039215686&step-up=11&step-down=7&hue-shift=0&name=cerulean-blue&overrides=e30%3D
    DEFAULT: "#2C59C6", // cerulean-blue
    50: "#F2F5FC",
    100: "#DBE3F7",
    200: "#ADC0ED",
    300: "#809CE3",
    400: "#5279D8",
    500: "#2C59C6",
    600: "#264CA9",
    700: "#1F3F8C",
    800: "#19326E",
    900: "#122451",
  },
  rnxgreen: {
    // https://www.tailwindshades.com/#color=159.23076923076923%2C56.52173913043479%2C63.921568627450974&step-up=7&step-down=11&hue-shift=0&name=bermuda&overrides=e30%3D
    DEFAULT: "#6FD7B3", // bermuda
    50: "#EDFAF5",
    100: "#DFF6EE",
    200: "#C3EEDF",
    300: "#A7E7D0",
    400: "#8BDFC2",
    500: "#6FD7B3",
    600: "#43CB9C",
    700: "#2EA77D",
    800: "#227B5D",
    900: "#16503C",
  },
  rnxorange: {
    // https://www.tailwindshades.com/#color=14.366197183098587%2C89.873417721519%2C69.01960784313725&step-up=6&step-down=10&hue-shift=0&name=tan-hide&overrides=e30%3D
    DEFAULT: "#F78B69", // tan-hide
    50: "#FEF0EC",
    100: "#FDE5DD",
    200: "#FCCEC0",
    300: "#FAB8A3",
    400: "#F9A186",
    500: "#F78B69",
    600: "#F46639",
    700: "#ED420D",
    800: "#BD350A",
    900: "#8D2707",
  },
}

export const palette = [
  colors.rnxgreen[600],
  colors.rnxgreen[400],
  colors.rnxblue[600],
  colors.rnxblue[400],
  colors.sky[600],
  colors.sky[400],
  colors.amber[600],
  colors.amber[400],
  colors.rnxorange[600],
  colors.rnxorange[400],
  colors.teal[600],
  colors.teal[400],
]

export const smallPalette = [palette[1], palette[3], palette[5]]

function* cycle<T>(arr: Array<T>) {
  let i = 0
  while (true) {
    i = i >= arr.length ? 0 : i
    yield arr[i]
    i += 1
  }
}

export const smallPaletteGen = cycle(smallPalette)

/**
 * Converts a hex color to RGBA format with specified alpha
 * @param hexColor - Hex color string (e.g., "#ff0000" or "#f00")
 * @param alpha - Alpha value between 0 and 1
 * @returns RGBA color string
 */
export function hexToRgba(hexColor: string, alpha: number): string {
  // Remove # if present
  const hex = hexColor.replace("#", "")

  // Handle 3-digit hex
  const fullHex =
    hex.length === 3
      ? hex
          .split("")
          .map((c) => c + c)
          .join("")
      : hex

  // Parse RGB values
  const r = parseInt(fullHex.substring(0, 2), 16)
  const g = parseInt(fullHex.substring(2, 4), 16)
  const b = parseInt(fullHex.substring(4, 6), 16)

  // Clamp alpha between 0 and 1
  const clampedAlpha = Math.max(0, Math.min(1, alpha))

  return `rgba(${r}, ${g}, ${b}, ${clampedAlpha})`
}

export type UIColorShade = 50 | 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900

// Hex value of a UI color shade, for inline styles: Tailwind cannot generate dynamic class names.
export function getUIColorHex(color: UIColor, shade: UIColorShade): string {
  const colorPalette = colors[color as keyof typeof colors] ?? colors.gray
  if (typeof colorPalette === "string") return colorPalette

  return colorPalette[shade]
}

// Diagonal stripes, the fill of the downgraded events.
export function getHatchedBackground(stripeHex: string, gapHex: string): string {
  return `repeating-linear-gradient(135deg, ${stripeHex} 0 5px, ${gapHex} 5px 10px)`
}
